import { render, staticRenderFns } from "./BaseEditor.vue?vue&type=template&id=1ea94934"
import script from "./BaseEditor.vue?vue&type=script&lang=js"
export * from "./BaseEditor.vue?vue&type=script&lang=js"
import style0 from "./BaseEditor.vue?vue&type=style&index=0&id=1ea94934&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports